<template>
    <div class="dsb-router-wrapper">
        <div class="dsb-router-header">
            <div class="dsb-title dsb-title-lg">
                <p>
                    <span v-if="activeTab == 1">Mein Konto</span>
                    <span v-if="activeTab == 2">Abonnement</span>
                    <span v-if="activeTab == 3">Abrechnung</span>
                </p>
            </div>
        </div>

        <div class="dsb-router-tabs">
            <div @click="activeTab = 1" class="tab-el " :class="{ 'tab-el-active': activeTab == 1 }">
                <p>Konto</p>
            </div>
            <div @click="activeTab = 2" class="tab-el " :class="{ 'tab-el-active': activeTab == 2 }">
                <p>Abonnement</p>
            </div>
            <div @click="activeTab = 3" class="tab-el " :class="{ 'tab-el-active': activeTab == 3 }">
                <p>Abrechnung</p>
            </div>
        </div>

        <Loader v-if="loading" />

        <div v-else>

            <div v-if="activeTab == 1" class="tab account" data-aos="fade-left">
                <div class="user-info">
                    <div class="user-details">
                        <div class="avatar">
                            <img />
                        </div>
                        <div class="user-text">
                            <div class="dsb-title dsb-title-ss">
                                <p>{{ userInfo.firstName }} {{ userInfo.lastName }}</p>
                            </div>
                            <div class="dsb-msg dsb-msg-grey">
                                <p>{{ userInfo.email }}</p>
                            </div>
                        </div>
                    </div>
                    <button class="dsb-btn">
                        <p>Profilbild aktualisieren</p>
                    </button>
                </div>

                <div class="profile-edit">
                    <div class="dsb-msg">
                        <p>Profil</p>
                    </div>
                    <!-- <div class="dsb-msg dsb-msg-grey">
                    <p>Statt dem Platzhalter müsste etwas relevantes stehen.</p>
                </div> -->

                    <form class="edit-form">
                        <div class="inputs-wrapper">
                            <div class="inputs-column">
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Vorname</label>
                                    <input class="edit-input" v-model="userInfo.firstName">
                                </div>
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Nachname</label>
                                    <input class="edit-input" v-model="userInfo.lastName">
                                </div>
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Geburtsdatum</label>
                                    <input class="edit-input" v-model="userInfo.birthday">
                                </div>
                                <div class="input-wrapper">
                                    <label class="dsb-msg">E-Mail</label>
                                    <input class="edit-input" v-model="userInfo.email">
                                </div>
                            </div>
                            <div class="inputs-column">
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Adresse</label>
                                    <input class="edit-input" v-model="userInfo.address">
                                </div>
                                <div class="inputs-row">
                                    <div class="input-wrapper xl">
                                        <label class="dsb-msg">Ort</label>
                                        <input class="edit-input" v-model="userInfo.city">
                                    </div>
                                    <div class="input-wrapper sm">
                                        <label class="dsb-msg">PLZ</label>
                                        <input class="edit-input" v-model="userInfo.zip">
                                    </div>
                                </div>
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Land</label>
                                    <select placeholder="Land" class="edit-input" v-model="userInfo.country">
                                        <option value="Land" disabled>
                                            Land
                                        </option>
                                        <option value="CH">
                                            Schweiz
                                        </option>
                                        <option value="DE">
                                            Deutschland
                                        </option>
                                        <option value="AU">
                                            Österreich
                                        </option>
                                    </select>
                                </div>
                                <div class="input-wrapper">
                                    <label class="dsb-msg">Telefonnnummer</label>
                                    <input class="edit-input" v-model="userInfo.mobile">
                                </div>
                            </div>
                        </div>
                        <button class="dsb-btn dsb-btn-lg">
                            <p>Abmelden</p>
                        </button>
                    </form>
                </div>
            </div>

            <div v-if="activeTab == 2" class="tab subscription" data-aos="fade-left">

                <div class="header">
                    <h3>Abonnement</h3>
                    <button v-if="hasPaymentAttempt" @click="handlePaymentSuccess(0)" class="refresh-btn"
                        :disabled="subscriptionLoading" title="Abonnement-Status aktualisieren">
                        <span v-if="subscriptionLoading">Aktualisierung...</span>
                        <span v-else>Status aktualisieren</span>
                    </button>
                </div>

                <Loader v-if="subscriptionLoading" />

                <div v-else>

                    <div class="subscription-details subscription-el">
                        <div class="about">
                            <div>
                                <p class="subscription-text">{{ currentSubscription?.plan?.name || 'Free' }}</p>
                                <p class="subscription-text-sm subscription-text-grey">
                                    <span v-if="subscription?.is_in_trial">Testphase bis {{ formatDate(new
                                        Date(subscription.trial_ends_at)) }}</span>
                                    <span v-else-if="isCancelledWithAccess">Gekündigt - Zugriff bis {{ formatDate(new
                                        Date(subscription.ends_at)) }}</span>
                                    <span v-else-if="subscription?.ends_at && subscription?.status === 'active'">Aktiv bis {{ formatDate(new
                                        Date(subscription.ends_at)) }}</span>
                                    <span
                                        v-else-if="subscription?.status === 'active' && !subscription?.ends_at">Aktives
                                        Abonnement</span>
                                    <span v-else-if="hasExpired">Abonnement abgelaufen</span>
                                    <span v-else-if="currentSubscription.valid_until">Gültig bis
                                        {{ formattedExpiryDate }}</span>
                                    <span v-else>Kein aktives Abonnement</span>
                                </p>
                            </div>

                            <div class="subscription-buttons">
                                <button v-if="!hasActiveSubscription && !isCancelledWithAccess" @click="openPlanModal" :disabled="paymentLoading"
                                    class="subscribe-btn">
                                    <p class="subscription-text-sm subscription-text-white">
                                        <span v-if="paymentLoading">Laden...</span>
                                        <span v-else>Jetzt abonnieren</span>
                                    </p>
                                </button>
                                <button v-else-if="hasActiveSubscription && !isCancelledWithAccess" @click="changePlan" :disabled="paymentLoading">
                                    <p class="subscription-text-sm subscription-text-white">
                                        <span v-if="paymentLoading">Laden...</span>
                                        <span v-else>Plan ändern</span>
                                    </p>
                                </button>
                            </div>
                        </div>
                        <div class="tags">
                            <div class="tag" :class="subscriptionStatusClass">
                                <p class="subscription-text-sm"
                                    :class="{ 'subscription-text-pink': subscription?.status === 'active' && !subscription?.is_in_trial && !isCancelledWithAccess, 'subscription-text-orange': subscription?.is_in_trial, 'subscription-text-grey': subscription?.status !== 'active' || isCancelledWithAccess }">
                                    {{ subscriptionStatusText }}
                                </p>
                            </div>
                            <div class="tag tag-grey">
                                <p class="subscription-text-sm subscription-text-grey">
                                    {{ currentSubscription?.billing_cycle === 'yearly' ? 'Jährlich abgerechnet' :
                                        'Monatlich abgerechnet' }}
                                </p>
                            </div>
                            <div class="total">
                                <p class="subscription-text-sm subscription-text-grey">
                                    Total: {{ currentSubscription?.plan?.price || 0 }},-
                                    {{ currentSubscription?.plan?.currency || 'CHF' }}
                                </p>
                            </div>
                        </div>

                        <!-- Cancelled subscription info -->
                        <div v-if="isCancelledWithAccess" class="subscription-info-box cancelled-info">
                            <div class="info-content">
                                <p class="info-title">Abonnement gekündigt</p>
                                <p class="info-text">
                                    Ihr Abonnement wurde am {{ formatDate(new Date(subscription.cancelled_at)) }} gekündigt.
                                    Sie haben noch {{ subscription.remaining_days }} {{ subscription.remaining_days === 1 ? 'Tag' : 'Tage' }} vollen Zugriff auf alle Features bis zum {{ formatDate(new Date(subscription.ends_at)) }}.
                                </p>
                                <p class="info-text" v-if="subscription.features">
                                    <strong>Ihre verbleibenden Benefits:</strong><br>
                                    • Bis zu {{ subscription.features.max_tickets }} Anfragen<br>
                                    • {{ subscription.features.document_storage }} Dokumentenspeicher<br>
                                    <span v-if="subscription.features.priority_support">• Priority Support</span>
                                    <span v-if="subscription.features.api_access"><br>• API Zugriff</span>
                                </p>
                            </div>
                        </div>

                        <!-- Expired subscription info -->
                        <div v-if="hasExpired" class="subscription-info-box expired-info">
                            <div class="info-content">
                                <p class="info-title">Abonnement abgelaufen</p>
                                <p class="info-text">
                                    Ihr Abonnement ist am {{ formatDate(new Date(subscription.ends_at)) }} abgelaufen.
                                    Schließen Sie jetzt ein neues Abonnement ab, um wieder vollen Zugriff zu erhalten.
                                </p>
                            </div>
                        </div>

                        <!-- Needs payment info -->
                        <div v-if="subscription?.needs_payment" class="subscription-info-box payment-required-info">
                            <div class="info-content">
                                <p class="info-title">Zahlung erforderlich</p>
                                <p class="info-text">
                                    Ihre letzte Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode,
                                    um Ihr Abonnement zu reaktivieren.
                                </p>
                            </div>
                        </div>

                        <!-- Action buttons for different states -->
                        <div class="subscription-actions">
                            <!-- Reactivate button for cancelled subscriptions -->
                            <button v-if="isCancelledWithAccess" @click="reactivateCurrentSubscription" 
                                :disabled="subscriptionLoading" class="reactivate-btn">
                                <p class="subscription-text-sm">
                                    <span v-if="subscriptionLoading">Laden...</span>
                                    <span v-else>Abonnement reaktivieren</span>
                                </p>
                            </button>

                            <!-- Cancel button for active non-cancelled subscriptions -->
                            <button v-else-if="hasActiveSubscription && !isCancelledWithAccess" 
                                @click="cancelCurrentSubscription" :disabled="subscriptionLoading"
                                class="cancel-btn">
                                <p class="subscription-text-sm">
                                    <span v-if="subscriptionLoading">Laden...</span>
                                    <span v-else>Abonnement kündigen</span>
                                </p>
                            </button>

                            <!-- Add payment method button for needs_payment -->
                            <button v-if="subscription?.needs_payment" @click="addPaymentMethodPayrexx" 
                                :disabled="paymentLoading" class="payment-btn">
                                <p class="subscription-text-sm subscription-text-white">
                                    <span v-if="paymentLoading">Laden...</span>
                                    <span v-else>Zahlungsmethode hinzufügen</span>
                                </p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab == 3" class="tab invoice" data-aos="fade-left">
                <div class="invoice-header">
                    <p>Zahlungsverlauf und Rechnungen</p>
                    <button @click="downloadInvoices" class="download-btn" :disabled="subscriptionLoading">
                        <img src="../../assets/icons/upload-icon.svg" alt="Download"
                            style="transform: rotate(180deg);" />
                        <span>Alle Rechnungen herunterladen</span>
                    </button>
                </div>

                <div class="payments-summary">
                    <div class="summary-card">
                        <h4>Nächste Zahlung</h4>
                        <p class="amount">{{ currentSubscription?.plan?.price || 0 }},-
                            {{ currentSubscription?.plan?.currency || 'CHF' }}</p>
                        <p class="date" v-if="subscription?.is_in_trial">Nach Testphase: {{ formatDate(new
                            Date(subscription.trial_ends_at)) }}</p>
                        <p class="date" v-else-if="nextBillingDate">{{ formatDate(new Date(nextBillingDate)) }}</p>
                        <p class="date" v-else>Keine aktive Rechnung</p>
                    </div>
                    <div class="summary-card">
                        <h4>Status</h4>
                        <p class="amount">{{ subscriptionStatusText }}</p>
                        <p class="date" v-if="subscription?.is_in_trial">Testphase bis {{ formatDate(new
                            Date(subscription.trial_ends_at)) }}</p>
                        <p class="date" v-else-if="subscription?.status === 'active'">Aktives Abonnement</p>
                        <p class="date" v-else>{{ subscription?.status || 'Inaktiv' }}</p>
                    </div>
                    <div class="summary-card">
                        <h4>Aktuelle Periode</h4>
                        <p class="amount">{{ currentSubscription?.billing_cycle === 'yearly' ? 'Jährlich' : 'Monatlich'
                            }}
                        </p>
                        <p class="date">Abrechnungszyklus</p>
                    </div>
                </div>

                <Loader v-if="subscriptionLoading" />

                <div v-else>
                    <div class="payments-filter">
                        <select v-model="paymentFilter" class="filter-select">
                            <option value="all">Alle Zahlungen</option>
                            <option value="completed">Abgeschlossen</option>
                            <option value="pending">Ausstehend</option>
                            <option value="failed">Fehlgeschlagen</option>
                        </select>
                        <input type="month" v-model="paymentMonth" class="month-filter" :max="currentMonth" />
                    </div>

                    <table class="payments-table" v-if="filteredPayments.length > 0">
                        <thead>
                            <tr>
                                <th>
                                    <p>Datum</p>
                                </th>
                                <th>
                                    <p>Produkt</p>
                                </th>
                                <th>
                                    <p>Betrag</p>
                                </th>
                                <th>
                                    <p>Status</p>
                                </th>
                                <th>
                                    <p>Aktionen</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in filteredPayments" :key="payment.id">
                                <td>
                                    <p>{{ formatDate(new Date(payment.date)) }}</p>
                                </td>
                                <td>
                                    <p>{{ payment.description }}</p>
                                </td>
                                <td>
                                    <p>{{ payment.currency }} {{ payment.amount.toFixed(2) }}</p>
                                </td>
                                <td class="payment-status">
                                    <p :class="getPaymentStatusClass(payment.status)">
                                        {{ getPaymentStatusText(payment.status) }}</p>
                                </td>
                                <td class="payment-actions">
                                    <button v-if="payment.status === 'completed' && payment.invoice_url"
                                        @click="downloadInvoice(payment.invoice_url)" class="invoice-btn"
                                        title="Rechnung herunterladen">
                                        <img src="../../assets/icons/upload-icon.svg" alt="Download"
                                            style="transform: rotate(180deg);" />
                                    </button>
                                    <button v-if="payment.status === 'failed'" @click="retryPayment(payment)"
                                        class="retry-btn">
                                        Wiederholen
                                    </button>
                                    <button v-if="payment.status === 'pending'" @click="openPaymentPage(payment)"
                                        class="retry-btn">
                                        Bezahlen
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-else class="no-payments">
                        <div class="no-payments-content">
                            <img src="../../assets/icons/empty_icon.png" alt="Keine Zahlungen" />
                            <h3>Keine Zahlungen gefunden</h3>
                            <p>Es wurden noch keine Zahlungen für Ihr Konto verarbeitet.</p>
                            <button @click="openPlanModal" class="upgrade-btn">
                                Jetzt abonnieren
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Plan Selection Modal -->
        <div v-if="showPlanModal" class="modal-overlay" @click="closePlanModal">
            <div class="plan-modal" @click.stop>
                <div class="plan-modal-header">
                    <h3>Plan auswählen</h3>
                    <button @click="closePlanModal" class="close-modal-btn">
                        <img src="../../assets/icons/close_btn.svg" alt="Close" />
                    </button>
                </div>

                <!-- Billing Cycle Toggle -->
                <div class="billing-cycle-toggle">
                    <button 
                        @click="selectedBillingCycle = 'monthly'" 
                        class="cycle-btn"
                        :class="{ 'active': selectedBillingCycle === 'monthly' }">
                        Monatlich
                    </button>
                    <button 
                        @click="selectedBillingCycle = 'yearly'" 
                        class="cycle-btn"
                        :class="{ 'active': selectedBillingCycle === 'yearly' }">
                        Jährlich
                        <span class="savings-badge">33% sparen</span>
                    </button>
                </div>

                <div class="plans-container">
                    <div v-for="plan in filteredPlans" :key="plan.id" class="plan-card"
                        :class="{ 'current-plan': currentSubscription?.plan?.name === plan.name }">
                        <div class="plan-header">
                            <h4>
                                {{ plan.name }}
                                <span v-if="plan.savings" class="plan-savings-badge">{{ plan.savings }}</span>
                            </h4>
                            <div class="plan-price">
                                <div class="price-wrapper">
                                    <span class="currency">{{ plan.currency }}</span>
                                    <span class="amount">{{ plan.billingCycle === 'yearly' && plan.monthlyEquivalent ? plan.monthlyEquivalent.toFixed(2) : plan.price }}</span>
                                    <span v-if="plan.originalPrice" class="original-price">{{ plan.currency }} {{ plan.originalPrice }}</span>
                                </div>
                                <span class="period">{{ plan.billingCycle === 'yearly' ? '/Monat' : '/Monat' }}</span>
                            </div>
                            <div v-if="plan.billingCycle === 'yearly'" class="monthly-equivalent">
                                ({{ plan.currency }} {{ plan.price.toFixed(2) }} jährlich abgerechnet)
                            </div>
                        </div>

                        <div class="plan-features">
                            <ul>
                                <li v-for="feature in plan.features" :key="feature">
                                    <img src="../../assets/icons/checkmark-circle.svg" alt="✓" />
                                    {{ feature }}
                                </li>
                            </ul>
                        </div>

                        <div class="plan-actions">
                            <button v-if="currentSubscription?.plan?.name === plan.name" class="plan-btn current"
                                disabled>
                                Aktueller Plan
                            </button>
                            <button v-else-if="plan.id === 'free'" @click="selectPlan(plan)" class="plan-btn free"
                                :disabled="paymentLoading">
                                {{ paymentLoading ? 'Laden...' : 'Zu Free wechseln' }}
                            </button>
                            <button v-else @click="selectPlan(plan)" class="plan-btn upgrade"
                                :disabled="paymentLoading">
                                {{ paymentLoading ? 'Laden...' : (hasActiveSubscription ? 'Plan wechseln' :
                                    'Abonnieren') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Cancellation Confirmation Modal -->
        <div v-if="showCancelModal" class="modal-overlay" @click="closeCancelModal">
            <div class="cancel-modal" @click.stop>
                <div class="cancel-modal-header">
                    <h3>Abonnement kündigen</h3>
                    <button @click="closeCancelModal" class="close-modal-btn">
                        <img src="../../assets/icons/close_btn.svg" alt="Close" />
                    </button>
                </div>

                <div class="cancel-modal-content">
                    <p class="cancel-warning">Achtung: Wichtiger Hinweis zu deiner Kündigung!</p>
                    <p class="cancel-info">Eine Kündigung deines Abonnements hat zur Folge, dass <span class="bold">alle aktuell laufenden Löschanträge sofort abgebrochen</span> werden. Die betroffenen Unternehmen bleiben somit weiterhin im Besitz deiner Daten.</p>
                    
                    <div class="cancel-details" v-if="subscription">
                        <div class="detail-row">
                            <span class="detail-label">Aktueller Plan:</span>
                            <span class="detail-value">{{ currentSubscription?.plan?.name || 'Free' }}</span>
                        </div>
                        <div class="detail-row" v-if="subscription?.ends_at">
                            <span class="detail-label">Zugriff bis:</span>
                            <span class="detail-value">{{ formatDate(new Date(subscription.ends_at)) }}</span>
                        </div>
                    </div>
                </div>

                <div class="cancel-modal-actions">
                    <button @click="closeCancelModal" class="btn-secondary">
                        Abbrechen
                    </button>
                    <button @click="confirmCancellation" :disabled="subscriptionLoading" class="btn-danger">
                        <span v-if="subscriptionLoading">Laden...</span>
                        <span v-else>Kündigung bestätigen</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Cancellation Info Modal -->
        <div v-if="showCancelInfoModal" class="modal-overlay" @click="closeCancelInfoModal">
            <div class="cancel-info-modal" @click.stop>
                <div class="cancel-info-modal-header">
                    <h3>Wusstest du schon?</h3>
                    <button @click="closeCancelInfoModal" class="close-modal-btn">
                        <img src="../../assets/icons/close_btn.svg" alt="Close" />
                    </button>
                </div>

                <div class="cancel-info-modal-content">
                    <p class="info-text">Es ist ratsam, deine Daten <span class="bold">regelmäßig</span> zu bereinigen, denn selbst Unternehmen, die deine Daten einmal gelöscht haben, können diese im Laufe der Zeit wieder neu sammeln.</p>
                    <p class="info-text"><span class="bold">Lass dir diesen Schutz nicht entgehen!</span> Wir erinnern dich gerne wieder daran, wann der nächste <span class="bold">Cleandata-Durchlauf</span> sinnvoll ist, damit dein digitales Leben sauber bleibt.</p>
                </div>

                <div class="cancel-info-modal-actions">
                    <button @click="closeCancelInfoModal" class="btn-primary">
                        Verstanden
                    </button>
                </div>
            </div>
        </div>

        <!-- Reactivation Confirmation Modal -->
        <div v-if="showReactivateModal" class="modal-overlay" @click="closeReactivateModal">
            <div class="reactivate-modal" @click.stop>
                <div class="reactivate-modal-header">
                    <h3>Abonnement reaktivieren</h3>
                    <button @click="closeReactivateModal" class="close-modal-btn">
                        <img src="../../assets/icons/close_btn.svg" alt="Close" />
                    </button>
                </div>

                <div class="reactivate-modal-content">
                    <p class="reactivate-info">Möchten Sie Ihr Abonnement wirklich reaktivieren?</p>
                    <p class="reactivate-details">
                        Ihr <strong>{{ currentSubscription?.plan?.name }}</strong> Abonnement wird reaktiviert und die 
                        Kündigung wird rückgängig gemacht. Die nächste Zahlung erfolgt am {{ formatDate(new Date(subscription?.ends_at)) }}.
                    </p>
                    
                    <div class="reactivate-benefits" v-if="subscription?.features">
                        <p class="benefits-title"><strong>Ihre Vorteile:</strong></p>
                        <ul>
                            <li>✓ Bis zu {{ subscription.features.max_tickets }} Anfragen pro Monat</li>
                            <li>✓ {{ subscription.features.document_storage }} Dokumentenspeicher</li>
                            <li v-if="subscription.features.priority_support">✓ Priority Support</li>
                            <li v-if="subscription.features.api_access">✓ API Zugriff</li>
                        </ul>
                    </div>
                </div>

                <div class="reactivate-modal-actions">
                    <button @click="closeReactivateModal" class="btn-secondary">
                        Abbrechen
                    </button>
                    <button @click="confirmReactivation" :disabled="subscriptionLoading" class="btn-primary">
                        <span v-if="subscriptionLoading">Laden...</span>
                        <span v-else>Reaktivierung bestätigen</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '../../components/Loader.vue';
import globalMixin from '../../mixins/globalMixin.js';

export default {
    mixins: [globalMixin],
    components: {
        Loader
    },
    data() {
        return {
            activeTab: 1,
            lastDataFetch: null, // Track when data was last fetched
            dataFreshnessDuration: 5 * 60 * 1000, // 5 minutes in milliseconds

            userInfo: {
                firstName: '',
                lastName: '',
                birthday: '',
                email: '',
                address: '',
                city: '',
                zip: '',
                country: '',
                mobile: '',
            },

            loading: false,
            subscriptionLoading: false,
            paymentLoading: false,
            showPlanModal: false,
            showCancelModal: false,
            showCancelInfoModal: false,
            showReactivateModal: false,
            successModalShown: false,
            selectedBillingCycle: 'monthly',

            // Payment monitoring
            paymentMonitoringInterval: null,
            isMonitoringPayment: false,

            // Payment history data - now loaded from store
            paymentFilter: 'all',
            paymentMonth: '',

            openCard: false,
            availablePlans: [
                {
                    id: 'free',
                    name: 'Basic',
                    price: 0,
                    currency: 'CHF',
                    billingCycle: 'monthly',
                    features: [
                        'Einmalige E-Mail-Prüfung pro Monat',
                        'Anzeige der Unternehmen mit Deinen Daten',
                        'Keine automatische Löschung möglich',
                        'Basis-Support'
                    ]
                },
                // Monthly plans
                {
                    id: 'standard_monthly',
                    name: 'Standard',
                    price: 14.95,
                    // originalPrice: 14.95,
                    currency: 'CHF',
                    billingCycle: 'monthly',
                    features: [
                        'Wöchentliche E-Mail-Prüfung',
                        'Anzeige der Unternehmen mit Deinen Daten',
                        'Automatische Löschung bei bis zu 5 Unternehmen pro Monat',
                        'Benachrichtigungen bei verdächtigen Aktivitäten',
                        'Priorisierter Support'
                    ]
                },
                {
                    id: 'pro_monthly',
                    name: 'Pro',
                    price: 29.95,
                    // originalPrice: 29.95,
                    currency: 'CHF',
                    billingCycle: 'monthly',
                    features: [
                        'Tägliche E-Mail-Prüfung',
                        'Anzeige der Unternehmen mit Deinen Daten',
                        'Unbegrenzte automatische Löschungen',
                        'Erweiterter Datenschutz',
                        'Premium-Support rund um die Uhr'
                    ]
                },
                // Yearly plans
                {
                    id: 'standard_yearly',
                    name: 'Standard',
                    price: 119.40,
                    originalPrice: 14.95,
                    monthlyEquivalent: 9.95,
                    currency: 'CHF',
                    billingCycle: 'yearly',
                    savings: '33% Ersparnis',
                    features: [
                        'Wöchentliche E-Mail-Prüfung',
                        'Anzeige der Unternehmen mit Deinen Daten',
                        'Automatische Löschung bei bis zu 5 Unternehmen pro Monat',
                        'Benachrichtigungen bei verdächtigen Aktivitäten',
                        'Priorisierter Support'
                    ]
                },
                {
                    id: 'pro_yearly',
                    name: 'Pro',
                    price: 239.40,
                    originalPrice: 29.95,
                    monthlyEquivalent: 19.95,
                    currency: 'CHF',
                    billingCycle: 'yearly',
                    savings: '33% Ersparnis',
                    features: [
                        'Tägliche E-Mail-Prüfung',
                        'Anzeige der Unternehmen mit Deinen Daten',
                        'Unbegrenzte automatische Löschungen',
                        'Erweiterter Datenschutz',
                        'Premium-Support rund um die Uhr'
                    ]
                }
            ],

            card: {
                nr1: '****',
                nr2: '****',
                nr3: '****',
                nr4: '2356',

                expireDay: '00',
                expireMonth: '00',

                code: '***',
            }
        }
    },
    computed: {
        formattedDate() {
            return this.formatDate(new Date());
        },
        currentSubscription() {
            return this.subscription || {
                plan: { name: 'Free', price: 0, currency: 'CHF' },
                status: 'inactive',
                valid_until: null,
                billing_cycle: 'monthly'
            };
        },
        subscriptionStatusText() {
            if (!this.subscription || this.subscription.status === 'inactive') return 'Inaktiv';
            
            // Check for cancelled subscription
            if (this.isCancelledWithAccess) {
                return `Gekündigt - ${this.subscription.remaining_days} ${this.subscription.remaining_days === 1 ? 'Tag' : 'Tage'} verbleibend`;
            }
            
            if (this.hasExpired) {
                return 'Abgelaufen';
            }
            
            if (this.subscription.status === 'active') {
                if (this.subscription.is_in_trial) {
                    return 'Testphase';
                }
                if (this.subscription.needs_payment) {
                    return 'Zahlung erforderlich';
                }
                return 'Aktiv';
            }
            if (this.subscription.status === 'pending') return 'Ausstehend';
            if (this.subscription.status === 'pending_payment') return 'Zahlung ausstehend';
            if (this.subscription.status === 'cancelled') return 'Gekündigt';
            return this.subscription.status;
        },
        subscriptionStatusClass() {
            if (!this.subscription || this.subscription.status === 'inactive') return 'tag-grey';
            
            // Cancelled subscriptions with remaining access
            if (this.isCancelledWithAccess) {
                return 'tag-grey';
            }
            
            // Expired subscriptions
            if (this.hasExpired) {
                return 'tag-red';
            }
            
            if (this.subscription.status === 'active') {
                if (this.subscription.is_in_trial) {
                    return 'tag-orange'; // Orange for trial period
                }
                if (this.subscription.needs_payment) {
                    return 'tag-red'; // Red for payment required
                }
                return 'tag-pink'; // Pink for active paid subscription
            }
            if (this.subscription.status === 'pending') return 'tag-orange';
            if (this.subscription.status === 'pending_payment') return 'tag-processing';
            if (this.subscription.status === 'cancelled') return 'tag-red';
            return 'tag-grey';
        },
        // Check if subscription is cancelled but still has access
        isCancelledWithAccess() {
            return this.subscription?.is_cancelled && 
                   this.subscription?.is_cancelled_with_access && 
                   !this.subscription?.has_expired;
        },
        // Check if subscription has expired
        hasExpired() {
            return this.subscription?.has_expired || 
                   (this.subscription?.is_cancelled && !this.subscription?.is_cancelled_with_access);
        },
        formattedExpiryDate() {
            if (!this.subscription?.valid_until) return 'Nicht verfügbar';
            return this.formatDate(new Date(this.subscription.valid_until));
        },
        filteredPayments() {
            let filtered = this.paymentHistory;

            // Filter by status
            if (this.paymentFilter !== 'all') {
                filtered = filtered.filter(payment => payment.status === this.paymentFilter);
            }

            // Filter by month
            if (this.paymentMonth) {
                const [year, month] = this.paymentMonth.split('-');
                filtered = filtered.filter(payment => {
                    const paymentDate = new Date(payment.date);
                    return paymentDate.getFullYear() == year &&
                        (paymentDate.getMonth() + 1) == month;
                });
            }

            return filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
        },
        yearlySpending() {
            const currentYear = new Date().getFullYear();
            const yearlyTotal = this.paymentHistory
                .filter(payment => {
                    const paymentDate = new Date(payment.date);
                    return paymentDate.getFullYear() === currentYear && payment.status === 'completed';
                })
                .reduce((total, payment) => total + payment.amount, 0);

            return `CHF ${yearlyTotal.toFixed(2)}`;
        },
        currentMonth() {
            const now = new Date();
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        },
        nextBillingDate() {
            return this.subscription?.next_billing_at || this.subscription?.valid_until;
        },
        paymentHistory() {
            return this.paymentHistoryFromStore || [];
        },
        paymentHistoryFromStore() {
            return this.$store.getters['payment/paymentHistory'];
        },
        hasPaymentAttempt() {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                return !!sessionStorage.getItem('payrexx_payment_attempt');
            }
            return false;
        },
        filteredPlans() {
            // Always show free plan, then filter by billing cycle
            const freePlan = this.availablePlans.find(p => p.id === 'free');
            const cyclePlans = this.availablePlans.filter(p => 
                p.id !== 'free' && p.billingCycle === this.selectedBillingCycle
            );
            return freePlan ? [freePlan, ...cyclePlans] : cyclePlans;
        }
    },
    methods: {
        formatDate(date) {
            return `${new Intl.DateTimeFormat('de-CH', {
                day: '2-digit', month: 'long', year: 'numeric'
            }).format(date)}`;
        },

        openPlanModal() {
            this.showPlanModal = true;
        },

        closePlanModal() {
            this.showPlanModal = false;
        },

        async selectPlan(plan) {
            try {
                this.paymentLoading = true;

                // If selecting free plan and user has active subscription, cancel it
                if (plan.id === 'free' && this.hasActiveSubscription) {
                    if (!confirm('Möchten Sie wirklich zum kostenlosen Plan wechseln? Ihr aktuelles Abonnement wird gekündigt.')) {
                        this.paymentLoading = false;
                        return;
                    }
                    await this.cancelSubscription();
                    this.closePlanModal();
                    this.$store.commit("application/setSuccessProcessModal", true);
                    this.$store.commit("application/setSuccessProcessTitle", 'Plan geändert');
                    this.$store.commit("application/setSuccessProcessText", 'Sie nutzen jetzt den kostenlosen Plan.');
                    await this.loadSubscriptionData(true);
                    return;
                }

                // For paid plans, create payment page
                if (plan.id !== 'free') {
                    let paymentPageData;
                    if (this.hasActiveSubscription) {
                        paymentPageData = await this.updateSubscription({
                            planId: plan.id,
                            planType: plan.billingCycle || 'monthly'
                        });
                    } else {
                        paymentPageData = await this.createPayrexxPaymentPage({
                            planId: plan.id,
                            planType: plan.billingCycle || 'monthly'
                        });
                    }

                    // Extract payment_url from the response structure
                    const paymentUrl = paymentPageData?.payment?.payment_url ||
                        paymentPageData?.payment_url ||
                        paymentPageData?.subscription?.payment_url ||
                        paymentPageData?.data?.payment_url;

                    if (paymentUrl) {
                        // Mark that a payment attempt is being made
                        sessionStorage.setItem('payrexx_payment_attempt', JSON.stringify({
                            planId: plan.id,
                            timestamp: Date.now()
                        }));
                        window.open(paymentUrl, '_blank');
                        this.closePlanModal();

                        // Start monitoring for payment completion
                        this.startPaymentMonitoring();
                    } else if (paymentPageData) {
                        // Subscription created but no payment page URL
                        this.closePlanModal();
                        this.$store.commit("application/setErrorProcessModal", true);
                        this.$store.commit("application/setErrorProcessTitle", 'Zahlungsseite nicht verfügbar');
                        this.$store.commit("application/setErrorProcessText", 'Die Zahlungsseite konnte nicht geladen werden. Bitte kontaktieren Sie den Support.');
                        await this.loadSubscriptionData(true);
                    } else {
                        // Handle error case
                        throw new Error('Zahlungsseite konnte nicht erstellt werden');
                    }
                }
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Fehler beim Planwechsel');
                this.$store.commit("application/setErrorProcessText", error.message || 'Ein unerwarteter Fehler ist aufgetreten.');
            } finally {
                this.paymentLoading = false;
            }
        },

        async changePlan() {
            // Open plan selection modal instead of auto-selecting
            this.openPlanModal();
        },
        async addPaymentMethodPayrexx() {
            try {
                this.paymentLoading = true;
                const paymentPageData = await this.addPaymentMethod({
                    subscriptionId: this.subscription?.id
                });

                if (paymentPageData?.payment_url) {
                    // Mark payment attempt for monitoring
                    sessionStorage.setItem('payrexx_payment_attempt', JSON.stringify({
                        action: 'add_payment_method',
                        timestamp: Date.now()
                    }));
                    window.open(paymentPageData.payment_url, '_blank');

                    // Start monitoring for payment completion
                    this.startPaymentMonitoring();
                }
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Fehler beim Hinzufügen der Zahlungsmethode');
                this.$store.commit("application/setErrorProcessText", error.message || 'Ein unerwarteter Fehler ist aufgetreten.');
            } finally {
                this.paymentLoading = false;
            }
        },
        cancelCurrentSubscription() {
            this.showCancelModal = true;
        },
        closeCancelModal() {
            this.showCancelModal = false;
        },
        async confirmCancellation() {
            try {
                this.subscriptionLoading = true;
                this.showCancelModal = false;
                await this.cancelSubscription();

                await this.loadSubscriptionData(true);
                
                // Show info modal after successful cancellation
                this.showCancelInfoModal = true;
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Fehler beim Kündigen');
                this.$store.commit("application/setErrorProcessText", error.message || 'Ein unerwarteter Fehler ist aufgetreten.');
            } finally {
                this.subscriptionLoading = false;
            }
        },
        closeCancelInfoModal() {
            this.showCancelInfoModal = false;
        },
        
        // Reactivation methods
        reactivateCurrentSubscription() {
            this.showReactivateModal = true;
        },
        closeReactivateModal() {
            this.showReactivateModal = false;
        },
        async confirmReactivation() {
            try {
                this.subscriptionLoading = true;
                this.showReactivateModal = false;
                
                await this.reactivateSubscription();
                
                // Refresh subscription data
                await this.loadSubscriptionData(true);
                
                // Show success message
                this.$store.commit("application/setSuccessProcessModal", true);
                this.$store.commit("application/setSuccessProcessTitle", 'Abonnement reaktiviert');
                this.$store.commit("application/setSuccessProcessText", `Ihr ${this.currentSubscription?.plan?.name || ''} Abonnement wurde erfolgreich reaktiviert. Die Kündigung wurde rückgängig gemacht.`);
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Fehler bei der Reaktivierung');
                this.$store.commit("application/setErrorProcessText", error.message || 'Ein unerwarteter Fehler ist aufgetreten.');
            } finally {
                this.subscriptionLoading = false;
            }
        },
        async loadSubscriptionData(forceRefresh = false) {
            // Check if data is still fresh (within 5 minutes) unless forced refresh
            const now = Date.now();
            if (!forceRefresh && this.lastDataFetch && (now - this.lastDataFetch) < this.dataFreshnessDuration) {
                return false; // Data is still fresh, no need to refetch
            }

            try {
                this.subscriptionLoading = true;
                const previousStatus = this.subscription?.status;

                await Promise.all([
                    this.fetchSubscription(),
                    this.fetchPaymentMethods(),
                    this.$store.dispatch('payment/fetchPaymentHistory')
                ]);

                // Update last fetch time
                this.lastDataFetch = now;

                // Check if subscription status improved
                if (previousStatus === 'pending_payment' && this.subscription?.status === 'active') {
                    // Auto-switch to Abonnement tab to show the updated subscription
                    this.activeTab = 2;
                    return true; // Indicate status change
                }

                return false;
            } catch (error) {
                return false;
            } finally {
                this.subscriptionLoading = false;
            }
        },
        async handlePayrexxCallback() {
            // Only handle callback if there's a payment attempt in session storage
            const lastPaymentAttempt = sessionStorage.getItem('payrexx_payment_attempt');
            if (!lastPaymentAttempt) {
                return; // No payment attempt to handle
            }

            try {
                // Set loading state
                this.subscriptionLoading = true;

                // Fetch fresh subscription data (force refresh for payment callbacks)
                await this.loadSubscriptionData(true);

                // Check if subscription status has changed to active and success modal hasn't been shown yet
                if (this.subscription && this.subscription.status === 'active' && !this.successModalShown) {
                    // Check if there was a recent payment attempt
                    const lastPaymentAttempt = sessionStorage.getItem('payrexx_payment_attempt');
                    if (lastPaymentAttempt) {
                        // Show success message only once
                        this.$store.commit("application/setSuccessProcessModal", true);
                        this.$store.commit("application/setSuccessProcessTitle", 'Zahlung erfolgreich');
                        this.$store.commit("application/setSuccessProcessText", 'Ihr Abonnement wurde erfolgreich aktiviert. Willkommen bei ' + (this.subscription.plan?.name || 'Ihrem neuen Plan') + '!');

                        // Mark success modal as shown and clear payment attempt
                        this.successModalShown = true;
                        sessionStorage.removeItem('payrexx_payment_attempt');

                        // Switch to subscription tab to show the updated status
                        this.activeTab = 2;
                    }
                } else if (this.subscription && this.subscription.status === 'pending_payment') {
                    // Payment might still be processing - user can manually refresh if needed
                }
            } catch (error) {
                // Don't show error to user as this might be normal page focus events
            } finally {
                this.subscriptionLoading = false;
            }
        },

        checkForPaymentCompletion() {
            // Check URL parameters for payment completion indicators
            const urlParams = new URLSearchParams(window.location.search);

            // Check multiple possible parameter names that Payrexx might use
            const paymentStatus = urlParams.get('payment_status') ||
                urlParams.get('status') ||
                urlParams.get('state') ||
                urlParams.get('result');

            const transactionState = urlParams.get('transaction_state') ||
                urlParams.get('transactionState');

            // Check for Payrexx-specific parameters
            const payrexxSuccess = urlParams.get('success');
            const payrexxResult = urlParams.get('result');

            // Check for payment completion indicators

            // Check for success indicators
            const isSuccess = paymentStatus === 'success' ||
                paymentStatus === 'completed' ||
                transactionState === 'FULFILL' ||
                transactionState === 'COMPLETED' ||
                payrexxSuccess === 'true' ||
                payrexxResult === 'success';

            // Check for failure indicators  
            const isFailed = paymentStatus === 'failed' ||
                paymentStatus === 'error' ||
                transactionState === 'FAILED' ||
                payrexxSuccess === 'false' ||
                payrexxResult === 'failed';

            if (isSuccess) {
                // Clean up URL
                window.history.replaceState({}, document.title, window.location.pathname);
                // Force immediate data refresh and handle the callback with retry logic
                this.handlePaymentSuccess();
                return true;
            } else if (isFailed) {
                // Clean up URL
                window.history.replaceState({}, document.title, window.location.pathname);
                // Show error message
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Zahlung fehlgeschlagen');
                this.$store.commit("application/setErrorProcessText", 'Ihre Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.');
                return true;
            } else if (paymentStatus === 'cancelled') {
                // Clean up URL
                window.history.replaceState({}, document.title, window.location.pathname);
                // Show cancellation message
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Abonnement gekündigt');
                this.$store.commit("application/setErrorProcessText", 'Ihr Abonnement wurde erfolgreich gekündigt.');
                return true;
            } else if (paymentStatus === 'cancel_failed') {
                // Clean up URL
                window.history.replaceState({}, document.title, window.location.pathname);
                // Show cancellation error
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Kündigung fehlgeschlagen');
                this.$store.commit("application/setErrorProcessText", 'Die Kündigung Ihres Abonnements konnte nicht verarbeitet werden. Bitte kontaktieren Sie den Support.');
                return true;
            }

            // If no URL parameters but we have a recent payment attempt, check subscription status
            const lastPaymentAttempt = sessionStorage.getItem('payrexx_payment_attempt');
            if (lastPaymentAttempt && !this.successModalShown) {
                // Delay check to allow page to load
                setTimeout(() => {
                    this.handlePaymentSuccess();
                }, 1000);
                return true;
            }

            return false;
        },

        async handlePaymentSuccess(retryCount = 0) {
            const maxRetries = 5;
            const baseRetryDelay = 2000; // 2 seconds base delay
            const retryDelay = baseRetryDelay * Math.pow(1.5, retryCount); // Exponential backoff

            // Show loading indicator for subscription activation
            this.subscriptionLoading = true;

            try {
                // Force fresh data fetch
                await this.loadSubscriptionData(true);

                // Check if subscription is now active
                if (this.subscription && this.subscription.status === 'active') {
                    // Success! Handle the callback and switch to subscription tab
                    this.subscriptionLoading = false;
                    this.activeTab = 2; // Auto-switch to Abonnement tab
                    this.handlePayrexxCallback();
                    this.stopPaymentMonitoring();
                    return;
                }

                // If subscription is still not active and we have retries left
                if (retryCount < maxRetries && this.subscription && (this.subscription.status === 'pending_payment' || this.subscription.status === 'pending')) {
                    // Show progress message to user on first retry
                    if (retryCount === 0) {
                        // Switch to subscription tab to show processing
                        this.activeTab = 2;
                        // Show initial processing message
                        this.$store.commit("application/setSuccessProcessModal", true);
                        this.$store.commit("application/setSuccessProcessTitle", 'Zahlung verarbeitet');
                        this.$store.commit("application/setSuccessProcessText", 'Ihre Zahlung wurde erfolgreich verarbeitet. Ihr Abonnement wird aktiviert...');
                    }

                    // Wait and retry with exponential backoff
                    setTimeout(() => {
                        this.handlePaymentSuccess(retryCount + 1);
                    }, retryDelay);
                } else {
                    // Either max retries reached or subscription is in unexpected state
                    this.subscriptionLoading = false;
                    this.activeTab = 2; // Switch to subscription tab anyway
                    this.handlePayrexxCallback(); // Try to handle anyway
                    this.stopPaymentMonitoring();
                }
            } catch (error) {
                // If error occurred, still try to handle callback
                this.subscriptionLoading = false;
                this.activeTab = 2; // Switch to subscription tab
                this.handlePayrexxCallback();
                this.stopPaymentMonitoring();
            }
        },

        // Payment history methods
        getPaymentStatusClass(status) {
            switch (status) {
                case 'completed': return 'status-completed';
                case 'pending': return 'status-pending';
                case 'failed': return 'status-failed';
                default: return '';
            }
        },

        getPaymentStatusText(status) {
            switch (status) {
                case 'completed': return 'Abgeschlossen';
                case 'pending': return 'Ausstehend';
                case 'failed': return 'Fehlgeschlagen';
                default: return status;
            }
        },

        async downloadInvoice(invoiceUrl) {
            try {
                // Open invoice in new tab
                window.open(invoiceUrl, '_blank');
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Download-Fehler');
                this.$store.commit("application/setErrorProcessText", 'Die Rechnung konnte nicht heruntergeladen werden.');
            }
        },

        async downloadInvoices() {
            try {
                this.subscriptionLoading = true;
                // TODO: Implement bulk invoice download
                this.$store.commit("application/setSuccessProcessModal", true);
                this.$store.commit("application/setSuccessProcessTitle", 'Download gestartet');
                this.$store.commit("application/setSuccessProcessText", 'Alle Rechnungen werden heruntergeladen.');
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Download-Fehler');
                this.$store.commit("application/setErrorProcessText", 'Die Rechnungen konnten nicht heruntergeladen werden.');
            } finally {
                this.subscriptionLoading = false;
            }
        },

        async retryPayment(payment) {
            try {
                this.paymentLoading = true;
                // Create payment page for failed payment
                // Try to extract plan info from payment description or use current subscription
                let planId = 'standard';
                let planType = 'monthly';

                if (payment.description.includes('Pro')) {
                    planId = 'pro';
                } else if (payment.description.includes('Standard')) {
                    planId = 'standard';
                } else if (payment.description.includes('Free')) {
                    planId = 'free';
                }

                if (payment.description.includes('Jährlich')) {
                    planType = 'yearly';
                }

                const paymentPageData = await this.createPayrexxPaymentPage({
                    planId: planId,
                    planType: planType
                });

                if (paymentPageData?.payment_url) {
                    // Mark payment attempt for monitoring
                    sessionStorage.setItem('payrexx_payment_attempt', JSON.stringify({
                        action: 'retry_payment',
                        planId: planId,
                        timestamp: Date.now()
                    }));
                    window.open(paymentPageData.payment_url, '_blank');

                    // Start monitoring for payment completion
                    this.startPaymentMonitoring();
                }
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Zahlungsfehler');
                this.$store.commit("application/setErrorProcessText", 'Die Zahlung konnte nicht wiederholt werden.');
            } finally {
                this.paymentLoading = false;
            }
        },

        async openPaymentPage(payment) {
            try {
                if (payment.invoice_url) {
                    window.open(payment.invoice_url, '_blank');
                } else {
                    this.$store.commit("application/setErrorProcessModal", true);
                    this.$store.commit("application/setErrorProcessTitle", 'Zahlungsseite nicht verfügbar');
                    this.$store.commit("application/setErrorProcessText", 'Die Zahlungsseite für diese Transaktion ist nicht verfügbar.');
                }
            } catch (error) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Fehler beim Öffnen der Zahlungsseite');
                this.$store.commit("application/setErrorProcessText", 'Die Zahlungsseite konnte nicht geöffnet werden.');
            }
        },

        setupVisibilityChangeDetection() {
            // Check for payment completion when page becomes visible
            const visibilityChangeHandler = () => {
                if (!document.hidden && this.isMonitoringPayment) {
                    // Page became visible, check for payment completion immediately
                    this.checkPaymentCompletion();
                }
            };

            document.addEventListener('visibilitychange', visibilityChangeHandler);

            // Store handler reference for cleanup
            this._visibilityChangeHandler = visibilityChangeHandler;
        },

        setupCrossTabPaymentDetection() {
            // Listen for localStorage changes from other tabs (payment completion)
            window.addEventListener('storage', (event) => {
                if (event.key === 'payrexx_payment_status' && event.newValue) {
                    const paymentData = JSON.parse(event.newValue);
                    if (paymentData.status === 'success') {
                        this.handlePaymentSuccess();
                        // Clean up the localStorage entry
                        localStorage.removeItem('payrexx_payment_status');
                        this.stopPaymentMonitoring();
                    }
                }
            });

            // Listen for postMessage from payment tabs
            window.addEventListener('message', (event) => {
                if (event.origin !== window.location.origin) return;

                if (event.data.type === 'PAYREXX_PAYMENT_SUCCESS') {
                    this.handlePaymentSuccess();
                    // Clean up any localStorage entry
                    localStorage.removeItem('payrexx_payment_status');
                    this.stopPaymentMonitoring();
                } else if (event.data.type === 'PAYREXX_PAYMENT_FAILED') {
                    this.$store.commit("application/setErrorProcessModal", true);
                    this.$store.commit("application/setErrorProcessTitle", 'Zahlung fehlgeschlagen');
                    this.$store.commit("application/setErrorProcessText", 'Die Zahlung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.');
                    this.stopPaymentMonitoring();
                } else if (event.data.type === 'PAYREXX_PAYMENT_CANCELLED') {
                    this.$store.commit("application/setErrorProcessModal", true);
                    this.$store.commit("application/setErrorProcessTitle", 'Zahlung abgebrochen');
                    this.$store.commit("application/setErrorProcessText", 'Sie haben die Zahlung abgebrochen. Sie können jederzeit ein Abonnement abschließen.');
                    this.stopPaymentMonitoring();
                }
            });

            // Also check on window focus in case storage event was missed
            window.addEventListener('focus', () => {
                const storedPaymentStatus = localStorage.getItem('payrexx_payment_status');
                if (storedPaymentStatus) {
                    const paymentData = JSON.parse(storedPaymentStatus);
                    if (paymentData.status === 'success') {
                        this.handlePaymentSuccess();
                        localStorage.removeItem('payrexx_payment_status');
                        this.stopPaymentMonitoring();
                    }
                }
            });
        },

        startPaymentMonitoring() {
            if (this.isMonitoringPayment) return; // Already monitoring

            this.isMonitoringPayment = true;

            // Check every 2 seconds for payment completion (more frequent)
            this.paymentMonitoringInterval = setInterval(() => {
                this.checkPaymentCompletion();
            }, 2000);

            // Also check when page becomes visible (user returns from payment)
            this.setupVisibilityChangeDetection();
        },

        stopPaymentMonitoring() {
            if (this.paymentMonitoringInterval) {
                clearInterval(this.paymentMonitoringInterval);
                this.paymentMonitoringInterval = null;
            }
            this.isMonitoringPayment = false;

            // Clean up visibility change listener
            if (this._visibilityChangeHandler) {
                document.removeEventListener('visibilitychange', this._visibilityChangeHandler);
                this._visibilityChangeHandler = null;
            }
        },

        async checkPaymentCompletion() {
            try {
                // Check localStorage for payment status from callback pages
                const storedPaymentStatus = localStorage.getItem('payrexx_payment_status');
                if (storedPaymentStatus) {
                    const paymentData = JSON.parse(storedPaymentStatus);
                    if (paymentData.status === 'success') {
                        localStorage.removeItem('payrexx_payment_status');
                        this.handlePaymentSuccess();
                        this.stopPaymentMonitoring();
                        return;
                    } else if (paymentData.status === 'cancelled') {
                        localStorage.removeItem('payrexx_payment_status');
                        this.$store.commit("application/setErrorProcessModal", true);
                        this.$store.commit("application/setErrorProcessTitle", 'Zahlung abgebrochen');
                        this.$store.commit("application/setErrorProcessText", 'Sie haben die Zahlung abgebrochen. Sie können jederzeit ein Abonnement abschließen.');
                        this.stopPaymentMonitoring();
                        return;
                    } else if (paymentData.status === 'failed') {
                        localStorage.removeItem('payrexx_payment_status');
                        this.$store.commit("application/setErrorProcessModal", true);
                        this.$store.commit("application/setErrorProcessTitle", 'Zahlung fehlgeschlagen');
                        this.$store.commit("application/setErrorProcessText", 'Die Zahlung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.');
                        this.stopPaymentMonitoring();
                        return;
                    }
                }

                // Also check if subscription status changed to active
                if (this.hasPaymentAttempt) {
                    await this.$store.dispatch('payment/fetchSubscription');
                    if (this.subscription?.status === 'active') {
                        this.handlePaymentSuccess();
                        this.stopPaymentMonitoring();
                        return;
                    }
                }
            } catch (error) {
                // Continue monitoring on error
            }
        }
    },
    async mounted() {
        this.loading = true;
        // Initialize payment month to current month
        const now = new Date();
        this.paymentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

        try {
            await this.getProfilelData();
            this.userInfo = this.userPersonalData;

            // Check for payment completion from URL parameters first (legacy support)
            const paymentCompleted = this.checkForPaymentCompletion();

            // Set up cross-tab payment detection
            this.setupCrossTabPaymentDetection();

            // Load subscription data to ensure it's available for all tabs
            await this.loadSubscriptionData(true);

            // If no URL parameters but we detect activation, show success once
            if (!paymentCompleted && this.subscription?.status === 'active') {
                // This might be a return from payment where status was updated
                const lastPaymentAttempt = sessionStorage.getItem('payrexx_payment_attempt');
                if (lastPaymentAttempt && !this.successModalShown) {
                    sessionStorage.removeItem('payrexx_payment_attempt');
                    this.$store.commit("application/setSuccessProcessModal", true);
                    this.$store.commit("application/setSuccessProcessTitle", 'Zahlung erfolgreich');
                    this.$store.commit("application/setSuccessProcessText", 'Ihr Abonnement wurde erfolgreich aktiviert!');
                    this.successModalShown = true;
                    this.activeTab = 2;
                }
            }
        } catch (error) {
            // Handle mount error silently
        } finally {
            this.loading = false;
        }

        // Start payment monitoring if there's an existing payment attempt
        if (this.hasPaymentAttempt) {
            this.startPaymentMonitoring();
        }
    },
    beforeUnmount() {
        // Clean up payment monitoring
        this.stopPaymentMonitoring();
        this.clearPayrexxPaymentPage();
    },
    watch: {
        activeTab(newTab) {
            // Only load subscription data for payment tab if we don't have recent data
            if (newTab === 2 && !this.subscription) {
                this.loadSubscriptionData(false).catch(() => {
                    // Handle error silently
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/dashboard.scss";
@import "@/assets/modals.scss";

.bold {
    font-weight: bold;
}

.dsb-router-wrapper {
    .edit-input {
        background-color: #F9F9F9 !important;
        border: none !important;
        color: rgba(0, 0, 0, 0.8) !important;

        &::placeholder {
            color: #00000080;
            //font-size: 14px;
        }
    }

    .input-wrapper label {
        font-size: 16px;
        margin-left: 10px;
        margin-bottom: 18px;
        display: block;
        color: rgba(0, 0, 0, 0.8);
    }

    .xl {
        width: 65%;
    }

    .sm {
        width: 30%;
    }

    .md {
        width: 48%;
    }

    .inputs-row {
        display: flex;
        justify-content: space-between;
    }
}

///////////

.account {
    .dsb-btn {
        margin: initial !important;
        border-radius: 20px !important;
    }
}

.user-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(112, 112, 112, 0.3);

    .dsb-btn {
        width: 212px;

        p {
            font-size: 14px;
        }
    }
}

.user-details {
    display: flex;
    gap: 24px;
    align-items: center;
}

.avatar {
    width: 122px;
    height: 122px;
    background: #D9D9D9;
    border-radius: 8px;

    img {
        width: 100%;
    }
}

.user-text {
    .dsb-title {
        margin-bottom: 16px;
    }
}

.profile-edit {
    padding-top: 30px;

    .dsb-msg:first-child {
        margin-bottom: 10px;

        p {
            font-weight: 600;
        }
    }

    .edit-form {
        margin-top: 30px;
        width: 78%;
    }

    .inputs-wrapper {
        display: flex;
        gap: 80px;
        margin-bottom: 30px;
    }

    .inputs-column {
        width: 50%;
    }

    .dsb-btn {
        width: 172px;
    }
}

///////////

.invoice {
    .dsb-btn {
        margin-top: 70px;
    }
}

.invoice-wrapper {
    display: flex;
    gap: 80px;
    width: 86%;
}



//invoice
.invoice-header {
    margin-bottom: 42px;

    p {
        font-size: 24px;
        color: #000000;
        font-weight: 500;
    }
}

.payments-table {
    width: 800px;
    border-collapse: collapse;

    thead {

        border-bottom: 1px solid #A7ADB4;

        tr {
            th {
                text-align: left;
                padding-bottom: 10px;

                p {
                    font-weight: 600;
                    font-size: 16px;
                    color: #000000;
                }
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #3d3d3d4d;

            td {
                padding: 15px 0;

                p {
                    font-size: 16px;
                    color: #000000;
                }
            }

            .payment-status {
                p {
                    color: #FF3A67;
                }
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }
}

///
/// 
/// subscription

.subscription {
    .header {
        margin-bottom: 42px;

        h3 {
            color: #000000;
            font-size: 24px;
            font-weight: 500;
            margin-bottom: 16px;
        }

        p {
            margin-bottom: 16px;
        }
    }
}


.subscription-el {
    box-shadow: 3px 6px 8px #FA3A671A;
    border-radius: 8px;
    padding: 24px;
    width: 648px;
}

.subscription-details {
    margin-bottom: 30px;

    .about {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}


.tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;

    .tag {
        padding: 8px 20px;
        border-radius: 5px;

        &-pink {
            background-color: rgba(250, 58, 103, 0.1);
        }

        &-grey {
            background-color: rgba(245, 245, 245, 1);
        }

        p {
            font-weight: 500;
        }
    }

    .key {
        display: flex;
        gap: 7px;
        align-items: center;

        .img {
            width: 21px;
            margin-top: 5px;

            img {
                width: 100%;
            }
        }
    }
}

.total {
    margin-left: auto;
}

.subscription button {
    border-radius: 5px;
    background-color: #FF3A67;
    padding: 8px 22px;
    border: none;
    cursor: pointer;
    transition: 0.3s ease;
    border: 1px solid #FF3A67;

    &:hover {
        background-color: white;

        p {
            color: #FF3A67;
        }
    }
}

.subscription-text {
    font-size: 20px;
    color: #000000;
    font-weight: 500;

    &-sm {
        font-size: 16px;
    }

    &-grey {
        color: #ada7a7;
    }

    &-pink {
        color: #FF3A67;
    }

    &-orange {
        color: #FF8C00;
    }

    &-white {
        color: #FFFFFF;
    }
}

.subscription-payment {
    position: relative;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 20px;
        border-bottom: 1px solid #A7ADB4;

        p {
            margin: 0;
        }

        button {
            p {
                color: white;
            }

            &:hover {
                p {
                    color: #FF3A67;
                }
            }
        }
    }

    .footer {
        display: flex;
        align-items: center;
        gap: 15px;

        p {
            font-weight: 500;

            span {
                color: #FF3A67;
            }
        }

        .img {
            margin-top: 9px;
            width: 43px;

            img {
                width: 100%;
            }
        }
    }
}

// New styles for Payrexx integration
.subscription-actions {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid rgba(112, 112, 112, 0.3);
    display: flex;
    gap: 15px;
    align-items: center;

    .cancel-btn,
    .reactivate-btn {
        background-color: transparent;
        border: 1px solid #FF3A67;
        border-radius: 5px;
        padding: 8px 22px;
        cursor: pointer;
        transition: 0.3s ease;

        p {
            color: #FF3A67;
            font-weight: 500;
        }

        &:hover {
            background-color: #FF3A67;

            p {
                color: white;
            }
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    .reactivate-btn {
        border-color: #28a745;

        p {
            color: #28a745;
        }

        &:hover {
            background-color: #28a745;

            p {
                color: white;
            }
        }
    }

    .payment-btn {
        background-color: #FF3A67;
        border: 1px solid #FF3A67;
        border-radius: 5px;
        padding: 8px 22px;
        cursor: pointer;
        transition: 0.3s ease;

        p {
            color: white;
            font-weight: 500;
        }

        &:hover {
            background-color: #E6335D;
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }
}

// Subscription info boxes
.subscription-info-box {
    margin-top: 20px;
    padding: 16px 20px;
    border-radius: 8px;
    display: flex;
    gap: 15px;
    align-items: flex-start;
    border-left: 4px solid;
    position: relative;

    &::before {
        content: 'ⓘ';
        font-size: 24px;
        font-weight: bold;
        margin-right: 10px;
        flex-shrink: 0;
    }

    .info-content {
        flex: 1;

        .info-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            color: #333;
        }

        .info-text {
            font-size: 14px;
            line-height: 1.6;
            color: #666;
            margin-bottom: 8px;

            &:last-child {
                margin-bottom: 0;
            }

            strong {
                color: #333;
                font-weight: 600;
            }
        }
    }

    &.cancelled-info {
        background-color: #fff3cd;
        border-color: #ffc107;
        
        &::before {
            content: 'ⓘ';
            color: #856404;
        }
    }

    &.expired-info {
        background-color: #f8d7da;
        border-color: #dc3545;
        
        &::before {
            content: '⚠';
            color: #721c24;
        }
    }

    &.payment-required-info {
        background-color: #f8d7da;
        border-color: #dc3545;
        
        &::before {
            content: '⚠';
            color: #721c24;
        }
    }
}

.payment-methods-list {
    .payment-method-item {
        margin-bottom: 15px;
        padding: 15px 0;

        &:not(:last-child) {
            border-bottom: 1px solid rgba(112, 112, 112, 0.2);
        }

        .footer {
            display: flex;
            align-items: center;
            gap: 15px;

            p {
                font-weight: 500;

                span {
                    color: #FF3A67;
                    font-weight: 600;
                }
            }

            .img {
                margin-top: 9px;
                width: 43px;

                img {
                    width: 100%;
                }
            }
        }
    }
}

.no-payment-methods {
    padding: 30px 20px;
    text-align: center;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin-top: 20px;

    p {
        color: #ada7a7;
        font-style: italic;
    }
}

.tag {
    &-pink {
        background-color: rgba(250, 58, 103, 0.1);

        p {
            color: #FF3A67;
        }
    }

    &-orange {
        background-color: rgba(255, 165, 0, 0.1);

        p {
            color: #FF8C00;
        }
    }

    &-red {
        background-color: rgba(220, 53, 69, 0.1);

        p {
            color: #DC3545;
        }
    }

    &-grey {
        background-color: rgba(245, 245, 245, 1);

        p {
            color: #ada7a7;
        }
    }

    &-processing {
        background-color: rgba(52, 152, 219, 0.1);

        p {
            color: #3498DB;
        }
    }
}

.cancel-info-modal {
    background: white;
    border-radius: 12px;
    padding: 32px;
    max-width: 640px;
    width: 90%;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);

    .cancel-info-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        h3 {
            font-size: 24px;
            font-weight: 600;
            color: #FF3A67;
            margin: 0;
        }

        .close-modal-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            transition: opacity 0.3s ease;

            &:hover {
                opacity: 0.7;
            }

            img {
                width: 24px;
                height: 24px;
            }
        }
    }

    .cancel-info-modal-content {
        margin-bottom: 32px;

        .info-text {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
            margin-bottom: 16px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .cancel-info-modal-actions {
        display: flex;
        gap: 12px;
        justify-content: center;

        button {
            padding: 12px 24px;
            border-radius: 8px;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;

            &.btn-primary {
                background-color: #FF3A67;
                color: white;
                border: 1px solid #FF3A67;
                min-width: 150px;

                &:hover:not(:disabled) {
                    background-color: #E6335D;
                }

                &:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            }

            &.btn-danger {
                background-color: #FF3A67;
                color: white;
                border: 1px solid #FF3A67;

                &:hover:not(:disabled) {
                    background-color: #E6335D;
                }

                &:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            }

            &.btn-secondary {
                background-color: transparent;
                color: #333;
                border: 1px solid #ddd;

                &:hover {
                    background-color: #f5f5f5;
                }
            }
        }
    }
}

// Reactivation modal styles
.reactivate-modal {
    background: white;
    border-radius: 12px;
    padding: 32px;
    max-width: 600px;
    width: 90%;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);

    .reactivate-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        h3 {
            font-size: 24px;
            font-weight: 600;
            color: #28a745;
            margin: 0;
        }

        .close-modal-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            transition: opacity 0.3s ease;

            &:hover {
                opacity: 0.7;
            }

            img {
                width: 24px;
                height: 24px;
            }
        }
    }

    .reactivate-modal-content {
        margin-bottom: 32px;

        .reactivate-info {
            font-size: 18px;
            font-weight: 600;
            color: #333;
            margin-bottom: 16px;
        }

        .reactivate-details {
            font-size: 16px;
            line-height: 1.6;
            color: #666;
            margin-bottom: 20px;

            strong {
                color: #333;
                font-weight: 600;
            }
        }

        .reactivate-benefits {
            background-color: #f8f9fa;
            padding: 16px;
            border-radius: 8px;
            border-left: 4px solid #28a745;

            .benefits-title {
                font-size: 16px;
                font-weight: 600;
                color: #333;
                margin-bottom: 12px;
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    font-size: 15px;
                    color: #555;
                    margin-bottom: 8px;
                    padding-left: 0;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .reactivate-modal-actions {
        display: flex;
        gap: 12px;
        justify-content: flex-end;

        button {
            padding: 12px 24px;
            border-radius: 8px;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s ease;
            border: none;
            min-width: 120px;

            &.btn-primary {
                background-color: #28a745;
                color: white;
                border: 1px solid #28a745;

                &:hover:not(:disabled) {
                    background-color: #218838;
                }

                &:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            }

            &.btn-secondary {
                background-color: transparent;
                color: #333;
                border: 1px solid #ddd;

                &:hover {
                    background-color: #f5f5f5;
                }
            }
        }
    }
}

.card-modal {
    padding: 35px;
    box-shadow: 0px 1px 30px #FA3A674D;
    border-radius: 20px;
    width: 436px;
    position: absolute;
    top: 0;
    right: -200px;
    background-color: white;
    z-index: 10;
    color: #A7ADB4;

    button {
        margin: 0 auto;
        width: 143px;
        display: block;
    }

    .card-label {
        margin-bottom: 10px;
    }

    .close-btn {
        position: absolute;
        top: 27px;
        left: 27px;
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .card-input {
        font-size: 20px;
        border: none;
        color: #A7ADB4;

        &:focus {
            outline: none;
        }
    }


    .card-stamps {
        display: flex;
        width: 100%;
        margin-bottom: 35px;
        gap: 2px;
        align-items: center;
        justify-content: flex-end;

        .visa-stamp {
            width: 56px;
            height: 24px;
        }

        .mc-stamp {
            width: 44px;
            height: 24px;
        }
    }

    .card-number {
        margin-bottom: 28px;
        border-bottom: 1px solid #A7ADB4;
        padding-bottom: 7px;

        .card-input {
            width: 25%;
        }
    }

    .card-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 35px;
    }


    .card-date {
        display: flex;
        gap: 7px;

        .card-input {
            width: 15%;
            text-align: center;

            border-bottom: 1px solid #A7ADB4;
            padding-bottom: 7px;
        }
    }

    .card-code {
        border-bottom: 1px solid #A7ADB4;
        padding-bottom: 7px;

        .card-input {
            width: 30%;
        }
    }
}


/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {

    .subscription-el {
        width: 680px;
    }


    .invoice-header p {
        font-size: 26px;
    }

    .payments-table {
        width: 900px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 18px;
            }
        }
    }
}

/* 2470 - 1328 */
@media (min-width: 2470px) {
    .dsb-router-wrapper .input-wrapper label {
        font-size: 18px;
    }

    .user-info .dsb-btn {
        width: 220px;

        p {
            font-size: 16px;
        }
    }

    .profile-edit {
        .dsb-btn {
            width: 180px;
        }
    }

    .avatar {
        width: 130px;
        height: 130px;
    }

    .user-info {
        padding-bottom: 40px;
    }

    .profile-edit {
        padding-top: 40px;
    }

    .profile-edit .edit-form {
        margin-top: 40px;
    }

    /// 



    /// 
    .subscription {
        .header {
            h3 {
                font-size: 26px;
            }
        }
    }



    .subscription-el {
        width: 720px;
    }

    .subscription button {
        padding: 10px 25px;
    }

    .tags .key .img {
        width: 25px;
        margin-top: 5px;
    }

    .subscription-payment .footer .img {
        margin-top: 9px;
        width: 48px;
    }

    .card-modal {
        width: 450px;

        .close-btn {
            width: 20px;
            height: 20px;
        }

        .card-stamps {
            .visa-stamp {
                width: 60px;
                height: 26px;
            }

            .mc-stamp {
                width: 50px;
                height: 26px;
            }
        }

        .card-input {
            font-size: 22px;
        }

        button {
            width: 160px;
        }
    }
}

/////
/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .subscription-el {
        width: 750px;
    }

    .payments-table {
        width: 1000px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 20px;
            }
        }
    }

    .invoice-header p {
        font-size: 28px;
    }
}

/*2573-1206*/
@media(min-width: 2573px) {
    .subscription-text {
        font-size: 22px;

        &-sm {
            font-size: 18px;
        }
    }
}

/* 2880-1670 */
@media(min-width: 2880px) {
    .dsb-router-wrapper .input-wrapper label {
        font-size: 20px;
    }

    .user-info .dsb-btn {
        width: 240px;

        p {
            font-size: 18px;
        }
    }

    .profile-edit {
        .dsb-btn {
            width: 200px;
        }
    }

    .avatar {
        width: 150px;
        height: 150px;
    }

    .user-info {
        padding-bottom: 50px;
    }

    .profile-edit {
        padding-top: 50px;
    }

    .profile-edit .edit-form {
        margin-top: 50px;
    }

    //

    .invoice-header p {
        font-size: 30px;
    }

    .payments-table {
        width: 1200px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 22px;
            }
        }
    }


    ///
    .subscription-text {
        font-size: 24px;

        &-sm {
            font-size: 20px;
        }
    }

    .subscription {
        .header {
            h3 {
                font-size: 28px;
            }
        }
    }

    //// 


    .subscription-el {
        width: 780px;
    }

    .tags {
        gap: 15px;
        margin: 30px 0;
    }

    th {
        padding-bottom: 20px;
    }

    td {
        padding-top: 20px;
    }


    .subscription button {
        padding: 12px 28px;
    }

    .tags .key .img {
        width: 30px;
        margin-top: 5px;
    }

    .subscription-payment .footer .img {
        margin-top: 9px;
        width: 53px;
    }

    .card-modal .card-label {
        margin-bottom: 20px;
    }

    .card-modal .card-info {
        margin-bottom: 45px;
    }

    .card-modal {
        width: 470px;
    }
}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {
    .dsb-router-wrapper .input-wrapper label {
        font-size: 22px;
    }

    .user-info .dsb-btn {
        width: 260px;

        p {
            font-size: 20px;
        }
    }

    .profile-edit {
        .dsb-btn {
            width: 220px;
        }
    }

    .avatar {
        width: 160px;
        height: 160px;
    }

    .user-info {
        padding-bottom: 60px;
    }

    .profile-edit {
        padding-top: 60px;
    }

    .profile-edit .edit-form {
        margin-top: 60px;
    }

    //

    .invoice-header p {
        font-size: 32px;
    }

    .payments-table {

        tbody tr td,
        thead tr th {
            p {
                font-size: 24px;
            }
        }
    }


    ///
    .subscription-text {
        font-size: 26px;

        &-sm {
            font-size: 22px;
        }
    }

    ////  

    .subscription {
        .header {
            h3 {
                font-size: 30px;
            }
        }
    }

    .subscription-el {
        width: 880px;
        padding: 30px;
    }

    .subscription-details {
        margin-bottom: 40px;
    }

    .subscription button {
        padding: 14px 30px;
    }

    .tags .key .img {
        width: 35px;
        margin-top: 5px;
    }

    .subscription-payment .footer .img {
        margin-top: 9px;
        width: 58px;
    }

    .card-modal {
        width: 500px;

        .close-btn {
            width: 22px;
            height: 22px;
        }

        .card-stamps {
            .visa-stamp {
                width: 64px;
                height: 30px;
            }

            .mc-stamp {
                width: 54px;
                height: 30px;
            }
        }

        .card-number {
            margin-bottom: 35px;
        }

        .card-input {
            font-size: 24px;
        }

        button {
            width: 180px;
        }
    }
}

/*3360-1890 1695*/
@media(min-width:3360px) {}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .dsb-router-wrapper .input-wrapper label {
        font-size: 26px;
    }

    .user-info .dsb-btn {
        width: 300px;

        p {
            font-size: 24px;
        }
    }

    .profile-edit {
        .dsb-btn {
            width: 250px;
        }
    }

    .avatar {
        width: 180px;
        height: 180px;
    }

    .user-info {
        padding-bottom: 70px;
    }

    .profile-edit {
        padding-top: 70px;
    }

    .profile-edit .edit-form {
        margin-top: 70px;
    }

    ///
    .invoice-header p {
        font-size: 36px;
    }

    .payments-table {
        width: 1400px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 26px;
            }
        }
    }

    /// 

    .subscription {
        .header {
            h3 {
                font-size: 34px;
            }
        }
    }

    .subscription-text {
        font-size: 30px;

        &-sm {
            font-size: 26px;
        }
    }

    //// 
    /// 
    /// 


    .subscription-el {
        width: 950px;
        padding: 40px;
    }

    .subscription-details {
        margin-bottom: 50px;
    }

    .subscription button {
        padding: 16px 32px;
    }

    .tags .key .img {
        width: 40px;
        margin-top: 5px;
    }

    .subscription-payment .footer .img {
        margin-top: 9px;
        width: 63px;
    }

    .card-modal {
        width: 600px;

        .close-btn {
            width: 26px;
            height: 26px;
        }

        .card-stamps {
            .visa-stamp {
                width: 70px;
                height: 34px;
            }

            .mc-stamp {
                width: 60px;
                height: 34px;
            }
        }

        .card-input {
            font-size: 28px;
        }

        button {
            width: 220px;
        }
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .card-modal {
        width: 420px;
    }
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {
    .invoice-header p {
        font-size: 22px;
    }
}

/*1640-1080*/
@media(max-width: 1640px) {
    .avatar {
        width: 110px;
        height: 110px;
    }

    .dsb-router-wrapper .input-wrapper label {
        font-size: 14px;
    }

    .user-info .dsb-btn {
        width: 180px;

        p {
            font-size: 14px;
        }
    }

    //// 
    .tags .tag {
        padding: 5px 15px;
    }

    .card-modal {
        width: 400px;
    }
}

/* 1600 - 757 */
@media (max-width: 1600px) {
    .invoice-wrapper {
        gap: 80px;
        width: 90%;
    }
}

/*1536-864*/
@media(max-width:1536px) {
    .invoice-wrapper {
        gap: 80px;
        width: 95%;
    }

    .card-modal {
        width: 380px;
        padding: 30px;
        right: -170px;

        .card-input {
            font-size: 18px;
        }
    }

    .invoice-header p {
        font-size: 20px;
    }

    .payments-table {
        width: 750px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 14px;
            }
        }
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    .profile-edit .edit-form {
        width: 85%;
    }

    .user-info .dsb-btn {
        width: 160px;

        p {
            font-size: 12px;
        }
    }

    // 

    .subscription-payment .footer .img {
        margin-top: 7px;
        width: 38px;
    }

    .tags .key .img {
        width: 18px;
        margin-top: 3px;
    }

    .card-modal {
        .close-btn {
            top: 24px;
            left: 24px;
        }

        .card-stamps {
            .visa-stamp {
                width: 50px;
                height: 20px;
            }

            .mc-stamp {
                width: 40px;
                height: 20px;
            }
        }
    }
}

/*1366-638*/
@media (max-width:1366px) {
    .invoice-wrapper {
        gap: 50px;
        width: 100%;
    }

    //
    .subscription-el {
        padding: 20px;
        width: 630px;
    }

    .subscription button {
        padding: 6px 18px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {
    .dsb-router-wrapper .input-wrapper label {
        font-size: 12px;
    }

    .avatar {
        width: 100px;
        height: 100px;
    }

    .profile-edit .edit-form {
        width: 90%;
    }

    .profile-edit .inputs-wrapper {
        gap: 60px;
    }

    .invoice-wrapper {
        gap: 0;
        justify-content: space-between;
    }


    .card-modal {
        width: 360px;
        padding: 25px;
        right: -160px;
    }
}

/* 1200-1920 */
@media (max-width:1200px) {
    .profile-edit .edit-form {
        width: 95%;
    }

    .profile-edit .inputs-wrapper {
        gap: 50px;
    }
}

/*1134x712*/
@media(max-width:1134px) {
    .profile-edit .edit-form {
        width: 100%;
    }

    .profile-edit .inputs-wrapper {
        gap: 40px;
    }


}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    .invoice-wrapper {
        flex-direction: column-reverse;
        gap: 50px;
    }

    .card-modal {
        right: -100px;
    }


    .invoice-header p {
        font-size: 18px;
    }

    .payments-table {
        width: 700px;
    }
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
    .subscription-el {
        padding: 20px;
        width: 100%;
    }

    .subscription .header h3 {
        font-size: 22px;
    }

    .card-modal {
        right: 0px;

        .card-input {
            font-size: 16px;
        }

        .card-code {
            padding-bottom: 0px;
        }
    }

    .subscription-text {
        font-size: 18px;

        &-sm {
            font-size: 14px;
        }
    }
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {
    .payments-table {
        width: 650px;
    }
}

/* 962x601 */
@media(max-width: 962px) {
    .payments-table {
        width: 550px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 13px;
            }
        }
    }
}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {
    .profile-edit .inputs-wrapper {
        gap: 20px;
    }

    .card-modal {
        width: 340px;
        padding: 20px;
    }
}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
    .user-info {
        flex-direction: column;
        align-items: flex-start;
        justify-content: initial;
        gap: 20px;

        .dsb-btn {
            margin: initial !important;
            margin-left: auto !important;
        }
    }

    .user-details {
        gap: 15px;
    }

    .avatar {
        width: 90px;
        height: 90px;
    }

    .profile-edit .inputs-wrapper {
        flex-direction: column;
        gap: 0px;
    }

    .profile-edit .inputs-column {
        width: 100%;
    }

    .profile-edit .dsb-btn {
        width: 165px;
        margin: 0 auto !important;
    }

    .input-wrapper {
        margin-bottom: 20px;
    }

    //// 

    .tags .tag {
        padding: 4px 12px;
    }

    .tags .key .img {
        width: 16px;
        margin-top: 2px;
    }

    .subscription-payment .footer .img {
        margin-top: 5px;
        width: 30px;
    }
}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {
    .payments-table {
        width: 500px;
    }
}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .avatar {
        width: 80px;
        height: 80px;
    }

    .payments-table {
        width: 100%;

        tbody tr td,
        thead tr th {
            p {
                font-size: 12px;
            }
        }
    }
}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {
    .avatar {
        width: 70px;
        height: 70px;
    }

    .card-modal {
        width: 80%;
        right: 4%;
    }

}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .payments-table {
        width: 500px;

        tbody tr td,
        thead tr th {
            p {
                font-size: 12px;
            }
        }
    }

    .invoice {
        overflow: scroll;
    }

}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .subscription-text {
        font-size: 16px;

        &-sm {
            font-size: 12px;
        }
    }

    .subscription .header {
        margin-bottom: 20px;

        h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        p {
            margin-bottom: 0px;
            font-size: 14px !important;
        }
    }

    .card-modal {
        .card-input {
            font-size: 14px;
        }

        .card-stamps {
            .visa-stamp {
                width: 40px;
                height: 15px;
            }

            .mc-stamp {
                width: 30px;
                height: 15px;
            }
        }

        .close-btn {
            top: 18px;
            left: 18px;
            width: 14px;
            height: 14px;
        }
    }
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {
    .user-info {
        .dsb-btn {
            width: 140px;

            p {
                font-size: 10px;
            }
        }
    }


    .invoice-wrapper {
        gap: 40px;
    }
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {
    .card-modal {
        width: 90%;
        right: 0%;
    }

    .subscription .header {
        h3 {
            font-size: 18px;
        }

        p {
            font-size: 12px !important;
        }
    }
}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {
    .subscription-el {
        padding: 10px;
        width: 100%;
    }

}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {

    .invoice-wrapper {
        gap: 30px;
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}

// Plan Modal Styles
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.plan-modal {
    background: white;
    border-radius: 12px;
    padding: 30px;
    max-width: 1000px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.plan-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    h3 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
        color: #000;
    }

    .close-modal-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px;

        img {
            width: 20px;
            height: 20px;
        }
    }
}

// Billing Cycle Toggle
.billing-cycle-toggle {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 30px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 10px;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;

    .cycle-btn {
        padding: 12px 30px;
        border: none;
        background: transparent;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 500;
        color: #666;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;

        &.active {
            background: white;
            color: #FF3A67;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        &:hover:not(.active) {
            color: #333;
        }

        .savings-badge {
            position: absolute;
            top: -8px;
            right: -8px;
            background: #28a745;
            color: white;
            font-size: 10px;
            padding: 3px 8px;
            border-radius: 10px;
            font-weight: 600;
            white-space: nowrap;
        }
    }
}

.plans-container {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
}

.plan-card {
    flex: 1;
    min-width: 250px;
    max-width: 280px;
    border: 2px solid #f0f0f0;
    border-radius: 12px;
    padding: 25px;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
        border-color: #FF3A67;
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(255, 58, 103, 0.1);
    }

    &.current-plan {
        border-color: #FF3A67;
        background-color: rgba(255, 58, 103, 0.05);

        &::before {
            content: "Aktueller Plan";
            position: absolute;
            top: -10px;
            left: 50%;
            transform: translateX(-50%);
            background: #FF3A67;
            color: white;
            padding: 5px 15px;
            border-radius: 15px;
            font-size: 12px;
            font-weight: 600;
        }
    }
}

.plan-header {
    margin-bottom: 25px;

    h4 {
        margin: 0 0 15px 0;
        font-size: 22px;
        font-weight: 600;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        .plan-savings-badge {
            font-size: 11px;
            background: #28a745;
            color: white;
            padding: 4px 10px;
            border-radius: 12px;
            font-weight: 600;
        }
    }

    .plan-price {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 5px;

        .price-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 2px;
        }

        .currency {
            font-size: 16px;
            color: #666;
        }

        .amount {
            font-size: 32px;
            font-weight: 700;
            color: #FF3A67;
        }

        .original-price {
            font-size: 14px;
            color: #999;
            text-decoration: line-through;
        }

        .period {
            font-size: 14px;
            color: #666;
        }
    }

    .monthly-equivalent {
        margin-top: 8px;
        font-size: 13px;
        color: #999;
        font-style: italic;
    }
}

.plan-features {
    margin-bottom: 30px;
    text-align: left;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 12px;
            font-size: 14px;
            color: #333;

            img {
                width: 16px;
                height: 16px;
                flex-shrink: 0;
            }
        }
    }
}

.plan-actions {
    .plan-btn {
        width: 100%;
        padding: 12px 20px;
        border-radius: 8px;
        border: none;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        font-size: 14px;

        &.current {
            background-color: #f5f5f5;
            color: #999;
            cursor: not-allowed;
        }

        &.free {
            background-color: #6c757d;
            color: white;

            &:hover:not(:disabled) {
                background-color: #5a6268;
            }
        }

        &.upgrade {
            background-color: #FF3A67;
            color: white;

            &:hover:not(:disabled) {
                background-color: #e8325a;
            }
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }
}

// Enhanced subscription buttons
.subscription-buttons {
    display: flex;
    gap: 10px;

    .subscribe-btn {
        background: linear-gradient(135deg, #FF3A67 0%, #e8325a 100%);
        box-shadow: 0 4px 15px rgba(255, 58, 103, 0.3);
        animation: pulse-subscribe 2s infinite;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(255, 58, 103, 0.4);
        }
    }
}

@keyframes pulse-subscribe {
    0% {
        box-shadow: 0 4px 15px rgba(255, 58, 103, 0.3);
    }

    50% {
        box-shadow: 0 4px 20px rgba(255, 58, 103, 0.5);
    }

    100% {
        box-shadow: 0 4px 15px rgba(255, 58, 103, 0.3);
    }
}

// Responsive styles for plan modal
@media (max-width: 768px) {
    .plans-container {
        flex-direction: column;
        align-items: center;
    }

    .plan-card {
        max-width: 100%;
    }

    .plan-modal {
        padding: 20px;
        margin: 10px;
    }
}

// Enhanced Payments Tab Styles
.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    p {
        font-size: 24px;
        color: #000000;
        font-weight: 500;
        margin: 0;
    }

    .download-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #FF3A67;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover:not(:disabled) {
            background: #e8325a;
            transform: translateY(-1px);
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        img {
            width: 16px;
            height: 16px;
        }

        span {
            font-size: 14px;
            font-weight: 500;
        }
    }
}

.payments-summary {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    flex-wrap: wrap;

    .summary-card {
        flex: 1;
        min-width: 200px;
        background: white;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        border: 1px solid #f0f0f0;

        h4 {
            margin: 0 0 10px 0;
            font-size: 14px;
            color: #666;
            font-weight: 500;
        }

        .amount {
            font-size: 24px;
            font-weight: 700;
            color: #FF3A67;
            margin: 0 0 5px 0;
        }

        .date {
            font-size: 12px;
            color: #999;
            margin: 0;
        }
    }
}

.payments-filter {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    align-items: center;
    flex-wrap: wrap;

    .filter-select,
    .month-filter {
        padding: 8px 12px;
        border: 1px solid #ddd;
        border-radius: 6px;
        background: white;
        font-size: 14px;
        color: #333;

        &:focus {
            outline: none;
            border-color: #FF3A67;
        }
    }

    .filter-select {
        min-width: 150px;
    }

    .month-filter {
        min-width: 130px;
    }
}

.payments-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    thead {
        background: #f8f9fa;

        tr th {
            text-align: left;
            padding: 15px;
            font-weight: 600;
            font-size: 14px;
            color: #333;
            border-bottom: 1px solid #eee;
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #f0f0f0;
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f8f9fa;
            }

            &:last-child {
                border-bottom: none;
            }

            td {
                padding: 15px;
                font-size: 14px;
                color: #333;

                p {
                    margin: 0;
                }
            }

            .payment-status {
                .status-completed {
                    color: #28a745;
                    font-weight: 500;
                }

                .status-pending {
                    color: #ffc107;
                    font-weight: 500;
                }

                .status-failed {
                    color: #dc3545;
                    font-weight: 500;
                }
            }

            .payment-actions {
                display: flex;
                gap: 8px;
                align-items: center;

                .invoice-btn {
                    background: none;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    padding: 6px;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        border-color: #FF3A67;
                        background: rgba(255, 58, 103, 0.1);
                    }

                    img {
                        width: 14px;
                        height: 14px;
                    }
                }

                .retry-btn {
                    background: #FF3A67;
                    color: white;
                    border: none;
                    padding: 6px 12px;
                    border-radius: 4px;
                    font-size: 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;

                    &:hover {
                        background: #e8325a;
                    }
                }
            }
        }
    }
}

.no-payments {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .no-payments-content {
        text-align: center;
        max-width: 400px;
        padding: 40px;

        img {
            width: 80px;
            height: 80px;
            margin-bottom: 20px;
            opacity: 0.5;
        }

        h3 {
            margin: 0 0 10px 0;
            font-size: 20px;
            color: #333;
        }

        p {
            margin: 0 0 20px 0;
            color: #666;
            line-height: 1.5;
        }

        .upgrade-btn {
            background: #FF3A67;
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 8px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: #e8325a;
                transform: translateY(-1px);
            }
        }
    }
}

// Responsive styles for payments
@media (max-width: 768px) {
    .invoice-header {
        flex-direction: column;
        gap: 15px;
        align-items: flex-start;
    }

    .payments-summary {
        flex-direction: column;
    }

    .payments-filter {
        flex-direction: column;
        align-items: flex-start;
    }

    .payments-table {
        font-size: 12px;

        thead tr th,
        tbody tr td {
            padding: 10px 8px;
        }
    }
}

.header {
    position: relative;

    .refresh-btn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #007bff;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover:not(:disabled) {
            background: #0056b3;
        }

        &:disabled {
            background: #6c757d;
            cursor: not-allowed;
        }
    }
}

// Cancellation Confirmation Modal
.cancel-modal {
    background: white;
    border-radius: 12px;
    padding: 0;
    max-width: 600px;
    width: 90%;
    box-shadow: 0px 10px 40px rgba(250, 58, 103, 0.2);

    .cancel-modal-header {
        padding: 24px;
        border-bottom: 1px solid rgba(112, 112, 112, 0.2);
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3 {
            font-size: 20px;
            font-weight: 600;
            color: #000000;
            margin: 0;
        }

        .close-modal-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s ease;

            img {
                width: 20px;
                height: 20px;
            }

            &:hover {
                opacity: 0.7;
            }
        }
    }

    .cancel-modal-content {
        padding: 24px;

        .cancel-warning {
            font-size: 16px;
            font-weight: 500;
            color: #000000;
            margin-bottom: 12px;
        }

        .cancel-info {
            font-size: 14px;
            color: #ada7a7;
            margin-bottom: 20px;
            line-height: 1.5;
        }

        .cancel-details {
            background-color: #f9f9f9;
            border-radius: 8px;
            padding: 16px;
            margin-top: 16px;

            .detail-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 0;

                &:not(:last-child) {
                    border-bottom: 1px solid rgba(112, 112, 112, 0.1);
                }

                .detail-label {
                    font-size: 14px;
                    color: #ada7a7;
                }

                .detail-value {
                    font-size: 14px;
                    font-weight: 500;
                    color: #000000;
                }
            }
        }
    }

    .cancel-modal-actions {
        padding: 24px;
        border-top: 1px solid rgba(112, 112, 112, 0.2);
        display: flex;
        gap: 12px;
        justify-content: flex-end;

        button {
            padding: 10px 24px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: 0.3s ease;
            border: none;

            &.btn-secondary {
                background-color: #f5f5f5;
                color: #000000;
                border: 1px solid #e0e0e0;

                &:hover {
                    background-color: #e0e0e0;
                }
            }

            &.btn-danger {
                background-color: #FF3A67;
                color: white;
                border: 1px solid #FF3A67;

                &:hover {
                    background-color: #e63359;
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }
        }
    }
}
</style>
